import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, type Rule } from "../lib/api";

export default function RuleDetail() {
  const { name } = useParams<{ name: string }>();
  const [rule, setRule] = useState<Rule | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!name) return;
    api<Rule>(`/governance/rules/${name}`)
      .then((r) => { setRule(r); setLoading(false); })
      .catch((e) => { setError(e.message); setLoading(false); });
  }, [name]);

  if (loading) return <div className="text-center py-8 text-gray-500">Loading {name}…</div>;
  if (error) return <div className="text-center py-8 text-red-600">Error: {error}</div>;
  if (!rule) return null;

  return (
    <div className="space-y-4">
      <Link to="/governance" className="text-sm text-growtify-500 hover:underline">← Back to Governance</Link>
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">{rule.name}</h1>
        <p className="text-xs text-gray-500 mt-1">
          v{rule.version} · {rule.scope} · updated {rule.updated_at}
        </p>
      </div>
      <pre className="rounded-lg border border-gray-200 bg-white p-6 text-sm overflow-x-auto whitespace-pre-wrap">
        {rule.body_md}
      </pre>
    </div>
  );
}
